// @router
import { RouteConfig } from "vue-router";

const newContainer = () => import("@/layouts/Default.vue");
const routerParent = () => import("@/components/base/routerParrent.vue");
const searchOrder = () => import("../views/order/searchOrder.vue");
const searchPaymentRule = () =>
  import("../views/paymentRule/searchPaymentRule.vue");
const searchParvandeh = () => import("../views/payment/searchParvandeh.vue");
const searchPayment = () => import("../views/payment/searchPayment.vue");
const searchDailyWorking = () =>
  import("../views/dailyWorking/searchDailyWorking.vue");
const myPayments = () => import("../views/payment/myPayments.vue");

export const cooperationRoutes: RouteConfig[] = [
  {
    path: "/cooperation",
    name: "dynamic_home",
    meta: {
      label: "خانه",
      requiresAuth: true,
    },
    component: newContainer,
    children: [
      {
        path: "order",
        name: "work_order",
        meta: {
          label: "سفارش کار",
          requiresAuth: true,
        },
        redirect: "/cooperation/order/search",
        component: routerParent,
        children: [
          {
            path: "search",
            name: "search_order",
            component: searchOrder,
            meta: {
              label: "لیست سفارش کار",
              requiresAuth: true,
              hasMaxWidth: false,
            },
          },
        ],
      },
      {
        path: "payment-rule",
        name: "payment_rule",
        meta: {
          label: "حکم حقوقی",
          requiresAuth: true,
        },
        redirect: "/cooperation/payment-rule/search",
        component: routerParent,
        children: [
          {
            path: "search",
            name: "search_payment_rule",
            component: searchPaymentRule,
            meta: {
              label: "لیست احکام حقوقی",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "payment",
        name: "payment_cooperation",
        meta: {
          label: "پرداخت",
          requiresAuth: true,
        },
        redirect: "/cooperation/payment/search-parvandeh",
        component: routerParent,
        children: [
          {
            path: "search-parvandeh",
            name: "search_payment_rule_parvandeh",
            component: searchParvandeh,
            meta: {
              label: "صورت وضعیت همکاری",
              requiresAuth: true,
            },
          },
          {
            path: "search-payment/:parvandehCode",
            name: "search_payment",
            component: searchPayment,
            meta: {
              label: "اسناد پرداخت",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "daily-working",
        name: "daily_working",
        meta: {
          label: "کارکرد روزانه",
          requiresAuth: true,
        },
        redirect: "/cooperation/daily-working/search",
        component: routerParent,
        children: [
          {
            path: "search/:id?",
            name: "search_daily_working",
            component: searchDailyWorking,
            meta: {
              label: "فهرست همکاری",
              requiresAuth: true,
              hasMaxWidth: false,
            },
          },
        ],
      },
      {
        path: "my-payment",
        name: "my-payment",
        meta: {
          label: "پرداخت های من",
          requiresAuth: true,
        },
        redirect: "/cooperation/my-payment/list",
        component: routerParent,
        children: [
          {
            path: "my-payments",
            name: "my_payment_cooperation",
            component: myPayments,
            meta: {
              label: "پرداخت های من",
              requiresAuth: true,
            },
          },
        ],
      },
    ],
  },
];
